import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";
import { useNavigate } from "react-router-dom";
import { MailOutlined } from "@ant-design/icons";
import "./Reset.css";
import Logo from "../../Components/Logo/Logo";
import axiosInstance from "../../Config/axiosConfig";

function Reset({ setLoggedIn, deviceId, userIp }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const formatPhoneNumber = (input) => {
    let formatted = input.replace(/\D/g, ""); // remove non-digits
    if (formatted.startsWith("0")) {
      formatted = "255" + formatted.slice(1);
    } else if (formatted.startsWith("2550")) {
      formatted = "255" + formatted.slice(4);
    }
    return formatted;
  };

  const isPhoneNumber = (input) => {
    const digitsOnly = input.replace(/\D/g, "");
    return digitsOnly.length >= 10 && /^\d+$/.test(digitsOnly);
  };

  const handleReset = async (values) => {
    setLoading(true);
    const storedDeviceId = deviceId;
    const storedUserIp = userIp;
    const input = values.emailOrPhone.trim();

    // Determine if input is phone number or email
    const username = isPhoneNumber(input) ? formatPhoneNumber(input) : input;

    try {
      const response = await axiosInstance.post(
        "/User/account-reset",
        { username },
        {
          headers: {
            UserDevice: storedDeviceId,
            UserIPAddress: storedUserIp,
          },
        }
      );

      message.success(response.data.message || "Reset instructions sent");
      navigate("/verify-otp", { state: { username } });

    } catch (error) {
      message.error(
        error.response?.data?.message ||
        "Failed to send reset instructions. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-page-container">
      <div className="reset-container">
        <Logo />
        <h3>Reset your account</h3>
        <span className="reset-text">Enter your email or phone number</span>

        <Form className="reset-form" layout="vertical" onFinish={handleReset}>
          <Form.Item
            name="emailOrPhone"
            rules={[
              {
                required: true,
                message: "Please enter your email or phone number",
              },
            ]}
          >
            <Input
              prefix={<MailOutlined />}
              placeholder="Email or Phone Number"
              className="reset-input"
            />
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            className="reset-button"
            loading={loading}
          >
            {loading ? "Sending..." : "Send Reset Instructions"}
          </Button>
        </Form>
      </div>
    </div>
  );
}

export default Reset;
